/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		7: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"route-home","1":"route-aboutTheData","2":"route-contact","3":"route-submitData","4":"route-map"}[chunkId]||chunkId) + ".chunk." + {"0":"dadbd","1":"8badf","2":"71488","3":"49310","4":"aed58","5":"1ce69"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "5Kdc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/topojson-client/src/reverse.js
/* harmony default export */ var reverse = (function (array, n) {
  var t,
      j = array.length,
      i = j - n;
  while (i < --j) {
    t = array[i], array[i++] = array[j], array[j] = t;
  }
});
// CONCATENATED MODULE: ../node_modules/topojson-client/src/identity.js
/* harmony default export */ var identity = (function (x) {
  return x;
});
// CONCATENATED MODULE: ../node_modules/topojson-client/src/transform.js


/* harmony default export */ var src_transform = (function (transform) {
  if (transform == null) return identity;
  var x0,
      y0,
      kx = transform.scale[0],
      ky = transform.scale[1],
      dx = transform.translate[0],
      dy = transform.translate[1];
  return function (input, i) {
    if (!i) x0 = y0 = 0;
    var j = 2,
        n = input.length,
        output = new Array(n);
    output[0] = (x0 += input[0]) * kx + dx;
    output[1] = (y0 += input[1]) * ky + dy;
    while (j < n) {
      output[j] = input[j], ++j;
    }return output;
  };
});
// CONCATENATED MODULE: ../node_modules/topojson-client/src/feature.js



/* harmony default export */ var feature = (function (topology, o) {
  return o.type === "GeometryCollection" ? { type: "FeatureCollection", features: o.geometries.map(function (o) {
      return feature_feature(topology, o);
    }) } : feature_feature(topology, o);
});

function feature_feature(topology, o) {
  var id = o.id,
      bbox = o.bbox,
      properties = o.properties == null ? {} : o.properties,
      geometry = object(topology, o);
  return id == null && bbox == null ? { type: "Feature", properties: properties, geometry: geometry } : bbox == null ? { type: "Feature", id: id, properties: properties, geometry: geometry } : { type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry };
}

function object(topology, o) {
  var transformPoint = src_transform(topology.transform),
      arcs = topology.arcs;

  function arc(i, points) {
    if (points.length) points.pop();
    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
      points.push(transformPoint(a[k], k));
    }
    if (i < 0) reverse(points, n);
  }

  function point(p) {
    return transformPoint(p);
  }

  function line(arcs) {
    var points = [];
    for (var i = 0, n = arcs.length; i < n; ++i) {
      arc(arcs[i], points);
    }if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
    return points;
  }

  function ring(arcs) {
    var points = line(arcs);
    while (points.length < 4) {
      points.push(points[0]);
    } // This may happen if an arc has only two points.
    return points;
  }

  function polygon(arcs) {
    return arcs.map(ring);
  }

  function geometry(o) {
    var type = o.type,
        coordinates;
    switch (type) {
      case "GeometryCollection":
        return { type: type, geometries: o.geometries.map(geometry) };
      case "Point":
        coordinates = point(o.coordinates);break;
      case "MultiPoint":
        coordinates = o.coordinates.map(point);break;
      case "LineString":
        coordinates = line(o.arcs);break;
      case "MultiLineString":
        coordinates = o.arcs.map(line);break;
      case "Polygon":
        coordinates = polygon(o.arcs);break;
      case "MultiPolygon":
        coordinates = o.arcs.map(polygon);break;
      default:
        return null;
    }
    return { type: type, coordinates: coordinates };
  }

  return geometry(o);
}
// EXTERNAL MODULE: ./utils/analytics.js
var analytics = __webpack_require__("QkG9");

// CONCATENATED MODULE: ./state/countries.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectors; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




// Inital state
var getInitialState = function getInitialState() {
	var state = {
		hasLoaded: false,
		hasLoadedEntities: false,
		hasLoadedSmall: false,
		hasFilledEntities: false,
		selected: null,
		hasSelected: false,
		highlighted: null,
		hasHighlighted: false,
		all: [],
		disputed: [],
		allRegions: [],
		allEntities: [],
		allOptions: {
			primaryFocus: [{
				value: 'Accelerating the clean energy transition',
				name: 'Clean energy transition'
			}, { value: 'Empowering women', name: 'Empowering women' }, {
				value: 'Addressing energy poverty',
				name: 'Energy poverty'
			}, {
				value: 'Moving Capital into Clean Energy/Climate Change',
				name: 'Moving capital into clean energy and climate change'
			}, {
				value: 'Promoting gender equality and social inclusion',
				name: 'Gender equality and social inclusion'
			}],
			organizationType: [{ value: 'Development Institution', name: 'Development institution' }, { value: 'Foundation/Charity', name: 'Foundation/charity' }, { value: 'Grassroots organization', name: 'Grass root organization' }, { value: 'International NGO', name: 'International NGO' }, { value: 'Private Enterprise', name: 'Private enterprise' }, {
				value: 'Research/Training Institution',
				name: 'Research/training institution'
			}, { value: 'Trade Association', name: 'Trade association' }, { value: '', name: '' }],
			annualBudget: [{ value: '>$5,000,000', name: '>$5,000,000' }, { value: '$1,000,000-$5,000,000', name: '$1,000,000 – $5,000,000' }, { value: '$500,000-$1,000,000', name: '$500,000 – $1,000,000' }, { value: '$100,000-$500,000', name: '$100,000 – $500,000' }, { value: '$10,000-$100,000', name: '$10,000 – $100,000' }, { value: '<$10,000', name: '<$10,000' }, { value: '', name: '' }],
			funderType: [{ value: 'Corporate', name: 'Corporate' }, { value: 'Development Institution', name: 'Development institution' }, { value: 'Foundation/Charity', name: 'Foundation/charity' }, { value: 'Individual', name: 'Individual' }, {
				value: 'Non-Profit Program Organization',
				name: 'Non-profit organization'
			}, { value: 'Other', name: 'Other' }, {
				value: 'Other Government Institutions',
				name: 'Government institution'
			}, { value: 'Special Purpose Vehicle', name: 'Special purpose vehicle' }, { value: '', name: '' }],
			implementerType: [{ value: 'Development institution', name: 'Development institution' }, { value: 'International NGO', name: 'International NGO' }, { value: 'Private sector', name: 'Private sector' }, { value: '', name: '' }, { value: 'Grassroots organization', name: 'Grass root organization' }, {
				value: 'Training/Research institution',
				name: 'Training/research institution'
			}, { value: 'Trade Association', name: 'Trade association' }, { value: 'Government', name: 'Government' }],
			barriers: [{
				value: 'Access to multi-year funding/investment',
				name: 'Access to multi-year funding'
			}, {
				value: 'High administrative costs',
				name: 'High administrative costs'
			}, { value: 'Lack of awareness', name: 'Lack of awareness' }, { value: 'Lack of growth capital', name: 'Lack of growth capital' }, {
				value: 'Lack of high quality data',
				name: 'Lack of high quality data'
			}, { value: 'Limited capacity', name: 'Limited capacity' }, { value: 'Limited incentives', name: 'Limited incentives' }, { value: 'Other', name: 'Other' }, {
				value: 'Political economy (cultural and social norms)',
				name: 'Social norms'
			}, { value: 'Unclear metrics', name: 'Unclear metrics' }, { value: '', name: '' }]
		},
		max: {
			region: 0,
			country: 0
		}
	};

	return state;
};

// Actions
var getCountry = function getCountry(countries, cid) {
	return countries.find(function (_ref) {
		var id = _ref.id;
		return id === cid;
	});
};
var countries_select = function select(state, id) {
	Object(analytics["a" /* trackEvent */])('Countries', 'Select', id);
	return _extends({}, state, { selected: id, hasSelected: true });
};
var highlight = function highlight(state, id) {
	return _extends({}, state, {
		highlighted: id,
		hasHighlighted: true
	});
};
var clearSelected = function clearSelected(state) {
	return _extends({}, state, { hasSelected: false });
};
var clearHighlighted = function clearHighlighted(state) {
	return _extends({}, state, { hasHighlighted: false });
};
var clear = function clear(state) {
	return _extends({}, state, {
		highlighted: null,
		selected: null
	});
};

var countries_setAll = function setAll(state, countriesTopo) {
	var next = _extends({}, state, {
		hasLoaded: true,
		all: feature(countriesTopo, countriesTopo.objects.countries).features.map(function (_ref2) {
			var properties = _ref2.properties,
			    rest = _objectWithoutProperties(_ref2, ['properties']);

			return _extends({}, rest, {
				id: properties.country
			}, properties);
		}).sort(function (a, b) {
			return a.country.localeCompare(b.country);
		}),
		disputed: feature(countriesTopo, countriesTopo.objects.disputed).features,
		allRegions: feature(countriesTopo, countriesTopo.objects.regions).features.map(function (_ref3) {
			var properties = _ref3.properties,
			    rest = _objectWithoutProperties(_ref3, ['properties']);

			return _extends({}, rest, properties);
		})
	});
	next.max = {
		region: next.allRegions.reduce(function (a, b) {
			return Math.max(a, b.entities.length);
		}, 0),
		country: next.all.reduce(function (a, b) {
			return Math.max(a, b.entities.length);
		}, 0)
	};

	if (state.allEntities.length > 0 && !next.hasFilledEntities) {
		next.all = next.all.map(function (feature) {
			return _extends({}, feature, {
				entities: feature.entities.map(function (eid) {
					return state.allEntities.find(function (entity) {
						return eid === +entity.id;
					});
				}).sort(function (a, b) {
					return a.name.localeCompare(b.name);
				})
			});
		});

		next.allRegions = next.allRegions.map(function (feature) {
			return _extends({}, feature, {
				entities: feature.entities.map(function (eid) {
					return state.allEntities.find(function (entity) {
						return eid === +entity.id;
					});
				}).sort(function (a, b) {
					return a.name.localeCompare(b.name);
				})
			});
		});
		next.hasFilledEntities = true;
	}

	return next;
};

var setEntities = function setEntities(state, entities) {
	var next = _extends({}, state, {
		hasLoadedEntities: true,
		allEntities: entities
	});

	if (state.all.length > 0 && !next.hasFilledEntities) {
		next.all = next.all.map(function (feature) {
			return _extends({}, feature, {
				entities: feature.entities.map(function (eid) {
					return next.allEntities.find(function (entity) {
						return eid === +entity.id;
					});
				}).sort(function (a, b) {
					return a.name.localeCompare(b.name);
				})
			});
		});

		next.allRegions = next.allRegions.map(function (feature) {
			return _extends({}, feature, {
				entities: feature.entities.map(function (eid) {
					return next.allEntities.find(function (entity) {
						return eid === +entity.id;
					});
				}).sort(function (a, b) {
					return a.name.localeCompare(b.name);
				})
			});
		});
		next.hasFilledEntities = true;
	}

	return next;
};

var countries_setSmall = function setSmall(state, countriesTopo) {
	return _extends({}, state, {
		hasLoadedSmall: true,
		smallTopo: {
			countries: feature(countriesTopo, countriesTopo.objects.countries).features.map(function (_ref4) {
				var properties = _ref4.properties,
				    rest = _objectWithoutProperties(_ref4, ['properties']);

				return _extends({}, rest, properties);
			}),
			regions: feature(countriesTopo, countriesTopo.objects.regions).features.map(function (_ref5) {
				var properties = _ref5.properties,
				    rest = _objectWithoutProperties(_ref5, ['properties']);

				return _extends({}, rest, properties);
			})
		}
	});
};

var actions = {
	select: countries_select,
	highlight: highlight,
	clearSelected: clearSelected,
	clearHighlighted: clearHighlighted,
	clear: clear,
	setAll: countries_setAll,
	setEntities: setEntities,
	setSmall: countries_setSmall
};

// Selectors
var getHighlightedCountry = function getHighlightedCountry(state) {
	return getCountry(getFiltered(state), state.countries.highlighted);
};

var getSelectedCountry = function getSelectedCountry(state) {
	if (!state.countries.selected) {
		return null;
	}

	var country = getCountry(getFiltered(state), state.countries.selected);

	return _extends({}, country, {
		totals: getTotals(state, country),
		empty: getEmpty(state, country)
	});
};

var getIsSelected = function getIsSelected(_ref6, id) {
	var countries = _ref6.countries;
	return id === countries.selected;
};

var getFilteredEntries = function getFilteredEntries(_ref7, entities) {
	var countries = _ref7.countries,
	    filters = _ref7.filters;
	var selected = filters.primaryFocus.selected;

	return entities.filter(function (entity) {
		return !selected || selected === entity.primaryFocus;
	});
};

var getFiltered = function getFiltered(state) {
	var _state$countries = state.countries,
	    all = _state$countries.all,
	    allRegions = _state$countries.allRegions,
	    view = state.view;

	var data = view === 'region' ? allRegions : all;

	return data.map(function (country) {
		var id = country.id,
		    entities = country.entities;

		return _extends({}, country, {
			isVisible: true,
			isSelected: getIsSelected(state, id),
			filteredEntities: getFilteredEntries(state, entities)
		});
	});
};

var getTotals = function getTotals(state, country) {
	var allOptions = state.countries.allOptions;

	var totals = Object.entries(allOptions).reduce(function (obj, _ref8) {
		var key = _ref8[0],
		    value = _ref8[1];

		obj[key] = value.map(function (option) {
			if (option.value === '') {
				return;
			}

			var count = country.filteredEntities.filter(function (entity) {
				if (typeof entity[key] !== 'undefined') {
					return entity[key].includes(option.value);
				}
				return entity[key] === option;
			}).length;

			return {
				name: option.name,
				value: option.value,
				count: count
			};
		}).filter(Boolean);
		return obj;
	}, {});

	return Object.entries(totals).reduce(function (obj, _ref9) {
		var key = _ref9[0],
		    value = _ref9[1];

		var total = value.reduce(function (a, b) {
			return a + b.count;
		}, 0);

		if (total === 0) {
			obj[key] = [];
		} else {
			obj[key] = value.map(function (option) {
				return _extends({}, option, {
					percentage: Math.round(option.count / total * 100)
				});
			});
		}

		return obj;
	}, {});
};

var getEmpty = function getEmpty(state, country) {
	var allOptions = state.countries.allOptions;


	return Object.entries(allOptions).reduce(function (obj, _ref10) {
		var _extends2;

		var key = _ref10[0],
		    value = _ref10[1];
		return _extends({}, obj, (_extends2 = {}, _extends2[key] = country.filteredEntities.filter(function (entity) {
			return entity[key] === '' || entity[key].length === 0 || entity[key].length === 1 && entity[key].includes('');
		}).length, _extends2));
	}, {});
};

var getMax = function getMax(state) {
	return state.countries.max[state.view];
};

var selectors = {
	getSelectedCountry: getSelectedCountry,
	getHighlightedCountry: getHighlightedCountry,
	getFiltered: getFiltered,
	getMax: getMax
};

/* harmony default export */ var countries = __webpack_exports__["b"] = ({ getInitialState: getInitialState, actions: actions, selectors: selectors });

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "8BXp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/header/style.css
var style = __webpack_require__("u3et");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./elements/container/index.js
var container = __webpack_require__("CKJr");

// EXTERNAL MODULE: ./elements/icon/index.js
var icon = __webpack_require__("yMZu");

// EXTERNAL MODULE: ./components/linkBlock/style.css
var linkBlock_style = __webpack_require__("SNoI");
var linkBlock_style_default = /*#__PURE__*/__webpack_require__.n(linkBlock_style);

// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__("9qb7");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// CONCATENATED MODULE: ./components/linkBlock/index.js





var linkBlock_LinkBlock = function LinkBlock(_ref) {
	var _ref$links = _ref.links,
	    links = _ref$links === undefined ? {} : _ref$links,
	    _ref$TagName = _ref.TagName,
	    TagName = _ref$TagName === undefined ? 'div' : _ref$TagName,
	    _ref$LinkType = _ref.LinkType,
	    LinkType = _ref$LinkType === undefined ? match["Link"] : _ref$LinkType,
	    _ref$tight = _ref.tight,
	    tight = _ref$tight === undefined ? false : _ref$tight,
	    _ref$highlightActive = _ref.highlightActive,
	    highlightActive = _ref$highlightActive === undefined ? true : _ref$highlightActive,
	    target = _ref.target;

	var extras = {};
	if (target) {
		extras.target = target;
	}

	return Object(preact_min["h"])(
		TagName,
		null,
		Object.entries(links).map(function (_ref2, i) {
			var _cn;

			var link = _ref2[0],
			    name = _ref2[1];
			return Object(preact_min["h"])(
				'span',
				null,
				i !== 0 ? ' ' : '',
				Object(preact_min["h"])(
					LinkType,
					{
						className: classnames_default()(linkBlock_style_default.a.link, (_cn = {}, _cn[linkBlock_style_default.a.tight] = tight, _cn)),
						activeClassName: highlightActive ? linkBlock_style_default.a.active : null,
						href: '' + link,
						rel: 'noopener', target: !link.includes('mailto:') ? target : null
					},
					Object(preact_min["h"])(
						'span',
						{ className: linkBlock_style_default.a.linkWrapper },
						name
					)
				)
			);
		})
	);
};

/* harmony default export */ var linkBlock = (linkBlock_LinkBlock);
// CONCATENATED MODULE: ./components/header/index.js






var objToHash = function objToHash(obj) {
	return Object.keys(obj).map(function (key) {
		return key + '=' + encodeURIComponent(obj[key]);
	}).join('&');
};

var header__ref2 = Object(preact_min["h"])(icon["a" /* default */], { icon: 'twitter', title: 'Share on Twitter' });

var header__ref3 = Object(preact_min["h"])(icon["a" /* default */], { icon: 'facebook', title: 'Share on Facebook' });

var _ref4 = Object(preact_min["h"])(icon["a" /* default */], { icon: 'linkedin', title: 'Share on LinkedIn' });

var _ref5 = Object(preact_min["h"])(icon["a" /* default */], { icon: 'mail', title: 'Share by email' });

var _ref6 = Object(preact_min["h"])(
	'a',
	{ href: '/' },
	Object(preact_min["h"])(
		'svg',
		{
			xmlns: 'http://www.w3.org/2000/svg',
			width: '256',
			height: '22',
			viewBox: '0 0 256 22'
		},
		Object(preact_min["h"])(
			'title',
			null,
			'Faces of Energy'
		),
		Object(preact_min["h"])(
			'defs',
			null,
			Object(preact_min["h"])(
				'linearGradient',
				{ x1: '-38.212%', y1: '45.975%', y2: '50%', id: 'a' },
				Object(preact_min["h"])('stop', { 'stop-color': '#C3F4D8', offset: '0%' }),
				Object(preact_min["h"])('stop', { 'stop-color': '#39B786', offset: '5.169%' }),
				Object(preact_min["h"])('stop', { 'stop-color': '#3C9A8A', offset: '20.425%' }),
				Object(preact_min["h"])('stop', { 'stop-color': '#38808B', offset: '51%' }),
				Object(preact_min["h"])('stop', { 'stop-color': '#2F658B', offset: '68%' }),
				Object(preact_min["h"])('stop', { 'stop-color': '#1D4B8C', offset: '85%' }),
				Object(preact_min["h"])('stop', { 'stop-color': '#413064', offset: '100%' })
			)
		),
		Object(preact_min["h"])('path', {
			d: 'M20.879 23.228v2.781h-8.208V35H9.647V14.75h12.096v2.781h-9.072v5.697h8.208zM36.929 35l-1.431-4.941h-6.48L27.587 35h-3.294l6.426-20.493h3.078L40.223 35h-3.294zm-2.079-7.425l-2.592-8.964-2.592 8.964h5.184zm9.435-2.7c0-6.642 2.349-10.449 8.343-10.449 2.403 0 3.78.459 4.752.864v2.889c-1.539-.621-2.727-.918-4.563-.918-3.861 0-5.427 2.619-5.427 7.614 0 4.995 1.566 7.614 5.427 7.614 1.836 0 3.024-.297 4.563-.918v2.889c-.972.405-2.349.864-4.752.864-5.994 0-8.343-3.807-8.343-10.449zm30.117-1.755v2.781h-8.424v6.318h9.288V35H62.954V14.75h12.312v2.781h-9.288v5.589h8.424zm12.945.108c4.212.567 6.669 1.512 6.669 5.643 0 3.834-2.268 6.453-7.695 6.453-2.025 0-4.617-.459-5.994-1.161v-3.024c1.107.486 3.051 1.323 5.805 1.323 3.645 0 4.725-1.485 4.725-3.402 0-2.241-.945-2.781-3.672-3.132-4.941-.621-6.858-1.944-6.858-5.643 0-2.97 1.674-5.859 7.182-5.859 2.619 0 4.455.459 5.481.972v2.943c-1.485-.648-3.321-1.053-5.319-1.053-3.159 0-4.239 1.296-4.239 3.024 0 2.187 1.242 2.565 3.915 2.916zm27.51 10.341c4.887 0 5.616-3.834 5.616-8.694 0-4.86-.729-8.694-5.616-8.694s-5.616 3.834-5.616 8.694c0 4.86.729 8.694 5.616 8.694zm0 1.701c-6.615 0-7.56-5.103-7.56-10.395s.945-10.395 7.56-10.395c6.615 0 7.56 5.103 7.56 10.395s-.945 10.395-7.56 10.395zm24.285-11.664v1.701h-8.694V35h-1.836V14.75h11.475v1.701h-9.639v7.155h8.694zm25.89-.486v2.781h-8.424v6.318h9.288V35h-12.312V14.75h12.312v2.781h-9.288v5.589h8.424zM185.861 35h-2.754l-8.802-14.391.081 14.391h-2.997V14.75h2.754l8.802 14.391-.081-14.391h2.997V35zm17.292-11.88v2.781h-8.424v6.318h9.288V35h-12.312V14.75h12.312v2.781h-9.288v5.589h8.424zm9.381 3.645V35h-3.024V14.75h6.588c5.238 0 6.912 2.349 6.912 6.021 0 2.619-.81 4.536-3.294 5.4L223.955 35h-3.537l-3.672-8.235h-4.212zm0-9.234v6.48h3.996c2.808 0 3.186-1.593 3.186-3.24 0-1.674-.378-3.24-3.186-3.24h-3.996zm24.258 17.793c-6.021 0-8.235-4.077-8.235-10.449s2.214-10.449 8.316-10.449c2.781 0 4.644.486 5.805 1.053v2.97c-1.89-.783-3.483-1.188-5.427-1.188-4.158 0-5.589 2.808-5.589 7.614 0 4.968 1.485 7.614 5.589 7.614 1.242 0 2.295-.162 2.889-.378v-5.535h-3.591v-2.727h6.615v10.233c-1.053.567-3.483 1.242-6.372 1.242zm27.984-20.574l-6.885 12.123V35h-3.078v-8.127l-6.885-12.123h3.429l4.995 9.45 4.995-9.45h3.429z',
			transform: 'translate(-9 -14)',
			fill: 'url(#a)',
			'fill-rule': 'nonzero'
		})
	)
);

var _ref7 = Object(preact_min["h"])(icon["a" /* default */], { icon: 'hamburger', size: 'm', title: 'Open menu' });

var _ref8 = Object(preact_min["h"])(icon["a" /* default */], { icon: 'close', size: 'm', title: 'Close menu' });

var header_Header = function Header(_ref) {
	var _social;

	var _ref$siteName = _ref.siteName,
	    siteName = _ref$siteName === undefined ? 'Faces of Energy' : _ref$siteName,
	    _ref$links = _ref.links,
	    links = _ref$links === undefined ? {
		'/explore-map': 'Explore map',
		'/submit-data': 'Submit data',
		'/about-the-data': 'About the data',
		'/contact': 'Contact'
	} : _ref$links,
	    _ref$url = _ref.url,
	    url = _ref$url === undefined ? "https://un-maps.beyondwordsstudio.com" : _ref$url,
	    _ref$prefill = _ref.prefill,
	    prefill = _ref$prefill === undefined ? "If we want to close the energy access gap and achieve #SDG7, women must be involved. Visit @seforallorg and @energia_org's new interactive website that maps where organizations are supporting gender equality in sustainable energy to become #SDG7AllEqual" : _ref$prefill;

	var tweetParams = {
		url: url,
		text: prefill
	};

	var fbParams = {
		u: url
	};

	var linkedinParams = {
		url: url + '?cache=' + "cf37402389",
		title: prefill,
		mini: true
	};

	var mailParams = {
		subject: siteName,
		body: '' + (prefill + ' – ' + url)
	};

	var social = (_social = {}, _social['https://twitter.com/share?' + objToHash(tweetParams)] = header__ref2, _social['https://www.facebook.com/sharer/sharer.php?' + objToHash(fbParams)] = header__ref3, _social['https://www.linkedin.com/shareArticle?' + objToHash(linkedinParams)] = _ref4, _social['mailto:?' + objToHash(mailParams)] = _ref5, _social);

	return Object(preact_min["h"])(
		'header',
		{ className: style_default.a.header },
		Object(preact_min["h"])(
			container["a" /* default */],
			{ className: style_default.a.inner, size: 'page' },
			Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])(
					'h1',
					{ className: style_default.a.headerTitle },
					_ref6
				)
			),
			Object(preact_min["h"])('input', { type: 'checkbox', id: 'menu', className: style_default.a.menuToggle }),
			Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])('div', { className: style_default.a.overlay }),
				Object(preact_min["h"])(
					'label',
					{ 'for': 'menu', className: style_default.a.hamburger },
					_ref7
				),
				Object(preact_min["h"])(
					'label',
					{ 'for': 'menu', className: style_default.a.hamburgerClose },
					_ref8
				),
				Object(preact_min["h"])(
					'div',
					{ className: style_default.a.links },
					Object(preact_min["h"])(
						'nav',
						{ className: style_default.a.navLinks },
						Object(preact_min["h"])(linkBlock, { links: links })
					),
					Object(preact_min["h"])(linkBlock, {
						links: social,
						tight: true,
						LinkType: 'a',
						rel: 'noopener',
						target: '_blank'
					})
				)
			)
		)
	);
};

/* harmony default export */ var header = (header_Header);
// EXTERNAL MODULE: ./components/footer/style.css
var footer_style = __webpack_require__("ZMjw");
var footer_style_default = /*#__PURE__*/__webpack_require__.n(footer_style);

// CONCATENATED MODULE: ./components/footer/index.js




var footer_Header = function Header(_ref) {
	var _ref$siteName = _ref.siteName,
	    siteName = _ref$siteName === undefined ? 'Faces of Energy' : _ref$siteName,
	    _ref$links = _ref.links,
	    links = _ref$links === undefined ? [{
		link: 'https://www.seforall.org/terms-service',
		name: 'Terms of service'
	}, { link: 'https://www.seforall.org/privacy-policy', name: 'Privacy policy' }] : _ref$links,
	    _ref$logos = _ref.logos,
	    logos = _ref$logos === undefined ? [{
		url: 'https://www.seforall.org',
		logo: '/seforall-logo-bw.svg',
		width: 80,
		height: 80,
		alt: 'SE4ALL'
	}, {
		url: 'http://www.energia.org',
		logo: '/energia-logo-bw.svg',
		width: 225,
		height: 65,
		alt: 'Energia'
	}] : _ref$logos;
	return Object(preact_min["h"])(
		'div',
		{ className: footer_style_default.a.wrapper },
		Object(preact_min["h"])(
			'footer',
			{ className: footer_style_default.a.footer },
			Object(preact_min["h"])(
				container["a" /* default */],
				{ className: footer_style_default.a.inner },
				Object(preact_min["h"])(
					'div',
					{ className: footer_style_default.a.links },
					links.map(function (_ref2) {
						var link = _ref2.link,
						    name = _ref2.name;
						return Object(preact_min["h"])(
							'span',
							{ className: footer_style_default.a.link },
							Object(preact_min["h"])(
								'a',
								{ href: link, rel: 'noopener', target: '_blank' },
								name
							),
							' '
						);
					})
				),
				Object(preact_min["h"])(
					'div',
					{ className: footer_style_default.a.logos },
					logos.map(function (_ref3) {
						var logo = _ref3.logo,
						    url = _ref3.url,
						    width = _ref3.width,
						    height = _ref3.height,
						    alt = _ref3.alt;
						return Object(preact_min["h"])(
							'span',
							{ className: footer_style_default.a.logo },
							Object(preact_min["h"])(
								'a',
								{ href: url, rel: 'noopener', target: '_blank' },
								Object(preact_min["h"])('img', { src: logo, alt: alt, width: width, height: height })
							),
							' '
						);
					})
				)
			)
		)
	);
};

/* harmony default export */ var footer = (footer_Header);
// EXTERNAL MODULE: ./layouts/main/style.css
var main_style = __webpack_require__("HwER");
var main_style_default = /*#__PURE__*/__webpack_require__.n(main_style);

// CONCATENATED MODULE: ./layouts/main/index.js







var main__ref2 = Object(preact_min["h"])(header, null);

var main__ref3 = Object(preact_min["h"])(footer, null);

var main_Main = function Main(_ref) {
	var _cn;

	var children = _ref.children,
	    _ref$includeFooter = _ref.includeFooter,
	    includeFooter = _ref$includeFooter === undefined ? true : _ref$includeFooter,
	    fullSize = _ref.fullSize;
	return Object(preact_min["h"])(
		'main',
		{ id: 'main', className: main_style_default.a.main },
		Object(preact_min["h"])(
			'div',
			{ className: main_style_default.a.header },
			main__ref2
		),
		Object(preact_min["h"])(
			'div',
			{ className: classnames_default()(main_style_default.a.inner, (_cn = {}, _cn[main_style_default.a.noFooter] = !includeFooter, _cn)) },
			Object(preact_min["h"])(
				container["a" /* default */],
				{ size: fullSize ? 'full' : 'medium' },
				children
			)
		),
		includeFooter && Object(preact_min["h"])(
			'div',
			{ className: main_style_default.a.footer },
			main__ref3
		)
	);
};

/* harmony default export */ var main = __webpack_exports__["a"] = (main_Main);

/***/ }),

/***/ "9qb7":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ "BViu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/unistore/dist/unistore.es.js
function n(n, t) {
  for (var u in t) {
    n[u] = t[u];
  }return n;
}function t(t) {
  var u = [];function r(n) {
    for (var t = [], r = 0; r < u.length; r++) {
      u[r] === n ? n = null : t.push(u[r]);
    }u = t;
  }function e(r, e, o) {
    t = e ? r : n(n({}, t), r);for (var f = u, i = 0; i < f.length; i++) {
      f[i](t, o);
    }
  }return t = t || {}, { action: function action(n) {
      function u(t) {
        e(t, !1, n);
      }return function () {
        for (var r = arguments, e = [t], o = 0; o < arguments.length; o++) {
          e.push(r[o]);
        }var f = n.apply(this, e);null != f && (f.then ? f.then(u) : u(f));
      };
    }, setState: e, subscribe: function subscribe(n) {
      return u.push(n), function () {
        r(n);
      };
    }, unsubscribe: r, getState: function getState() {
      return t;
    } };
}/* harmony default export */ var unistore_es = (t);
//# sourceMappingURL=unistore.es.js.map
// EXTERNAL MODULE: ./state/countries.js + 4 modules
var countries = __webpack_require__("5Kdc");

// EXTERNAL MODULE: ./state/filters.js
var filters = __webpack_require__("OwCi");

// EXTERNAL MODULE: ./state/map.js
var map = __webpack_require__("zhmh");

// EXTERNAL MODULE: ./state/view.js
var view = __webpack_require__("f43Y");

// EXTERNAL MODULE: ./state/breakdown.js
var breakdown = __webpack_require__("LSJ/");

// EXTERNAL MODULE: ./state/accordian.js
var accordian = __webpack_require__("t8lY");

// CONCATENATED MODULE: ./state/store.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var store = unistore_es(_extends({
	breakdown: breakdown["b" /* default */].getInitialState(),
	map: map["b" /* default */].getInitialState(),
	filters: filters["b" /* default */].getInitialState(),
	countries: countries["b" /* default */].getInitialState(),
	accordian: accordian["b" /* default */].getInitialState()
}, view["b" /* default */].getInitialState()));

/* harmony default export */ var state_store = __webpack_exports__["a"] = (store);

/***/ }),

/***/ "CKJr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__("Di9F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("9qb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
	var _cn;

	var _ref$size = _ref.size,
	    size = _ref$size === undefined ? 'large' : _ref$size,
	    children = _ref.children,
	    className = _ref.className;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{
			className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style_css___default.a.container, (_cn = {}, _cn[__WEBPACK_IMPORTED_MODULE_1__style_css___default.a[size]] = true, _cn[className] = className, _cn))
		},
		children
	);
});

/***/ }),

/***/ "Di9F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"cb_cb","full":"cb_ce","page":"cb_cg","xlarge":"cb_ci","large":"cb_g","medium":"cb_ck","small":"cb_cm"};

/***/ }),

/***/ "FWi5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HwER":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"as_as","inner":"as_au","noFooter":"as_aw","header":"as_ay","footer":"as_a0"};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./style.css
var style = __webpack_require__("FWi5");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/unistore/preact.js
var preact = __webpack_require__("o6ac");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ./utils/analytics.js
var analytics = __webpack_require__("QkG9");

// EXTERNAL MODULE: ./state/store.js + 1 modules
var store = __webpack_require__("BViu");

// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/home.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				cb( __webpack_require__("Ukh+") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var home = (async_default()(load));
	
// CONCATENATED MODULE: ./routes/map.js

		

		function map_load(cb) {
			__webpack_require__.e/* require.ensure */(4).then((function (require) {
				cb( __webpack_require__("Ist/") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var map = (async_default()(map_load));
	
// CONCATENATED MODULE: ./routes/submitData.js

		

		function submitData_load(cb) {
			__webpack_require__.e/* require.ensure */(3).then((function (require) {
				cb( __webpack_require__("0+iU") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var submitData = (async_default()(submitData_load));
	
// CONCATENATED MODULE: ./routes/aboutTheData.js

		

		function aboutTheData_load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function (require) {
				cb( __webpack_require__("nVJz") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var aboutTheData = (async_default()(aboutTheData_load));
	
// CONCATENATED MODULE: ./routes/contact.js

		

		function contact_load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function (require) {
				cb( __webpack_require__("nEvm") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var contact = (async_default()(contact_load));
	
// CONCATENATED MODULE: ./index.js













if (false) {
	require('preact/debug');
}

var index_updatePage = function updatePage() {
	if (typeof document !== 'undefined') {
		var main = document.getElementById('main');
		if (main) {
			main.scrollTop = 0;
		}

		Object(analytics["b" /* trackPageview */])();

		var menu = document.getElementById('menu');
		if (menu) {
			menu.checked = false;
		}
	}
};

var isUCBrowser = function isUCBrowser() {
	if (typeof document !== 'undefined') {
		return navigator.userAgent.includes('SamsungBrowser') ? 'samsung-browser' : '';
	}
	return '';
};

var _ref = Object(preact_min["h"])(
	preact["Provider"],
	{ store: store["a" /* default */] },
	Object(preact_min["h"])(
		preact_router_es["Router"],
		{ onChange: index_updatePage },
		Object(preact_min["h"])(home, { path: '/' }),
		Object(preact_min["h"])(submitData, { path: '/submit-data', key: 'submit' }),
		Object(preact_min["h"])(map, { path: '/explore-map', key: 'map' }),
		Object(preact_min["h"])(aboutTheData, { path: '/about-the-data', key: 'about' }),
		Object(preact_min["h"])(contact, { path: '/contact' })
	)
);

/* harmony default export */ var index = __webpack_exports__["default"] = (function () {
	return Object(preact_min["h"])(
		'div',
		{ className: isUCBrowser() },
		_ref
	);
});

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink\:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "LSJ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getInitialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_analytics__ = __webpack_require__("QkG9");


var getInitialState = function getInitialState() {
	return {
		selected: 'organizationType'
	};
};

var actions = {
	select: function select(state, id) {
		Object(__WEBPACK_IMPORTED_MODULE_0_utils_analytics__["a" /* trackEvent */])('Breakdown viz', 'Update', id);
		return {
			selected: id
		};
	}
};

/* harmony default export */ __webpack_exports__["b"] = ({
	getInitialState: getInitialState,
	actions: actions
});

/***/ }),

/***/ "OrX5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"a4_a4"};

/***/ }),

/***/ "OwCi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getInitialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_analytics__ = __webpack_require__("QkG9");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var getInitialState = function getInitialState() {
	return {
		primaryFocus: {
			title: 'Show programs and organizations who focus on:',
			options: [{
				name: 'Clean energy transition',
				id: 'Accelerating the clean energy transition'
			}, { name: 'Empowering women', id: 'Empowering women' }, { name: 'Energy poverty', id: 'Addressing energy poverty' }, {
				name: 'Gender equality and social inclusion',
				id: 'Promoting gender equality and social inclusion'
			}, {
				name: 'Moving capital into clean energy and climate change',
				id: 'Moving Capital into Clean Energy/Climate Change'
			}],
			selected: null
		}
	};
};

var actions = {
	updateFilter: function updateFilter(state, id, selected) {
		var _extends2;

		Object(__WEBPACK_IMPORTED_MODULE_0_utils_analytics__["a" /* trackEvent */])('Filter ' + id, 'Update', selected);
		return _extends({}, state, (_extends2 = {}, _extends2[id] = _extends({}, state[id], { selected: selected }), _extends2));
	},
	clearFilter: function clearFilter(state, id) {
		var _extends3;

		Object(__WEBPACK_IMPORTED_MODULE_0_utils_analytics__["a" /* trackEvent */])('Filter ' + id, 'Update', 'Default');
		return _extends({}, state, (_extends3 = {}, _extends3[id] = _extends({}, state[id], { selected: null }), _extends3));
	}
};

/* harmony default export */ __webpack_exports__["b"] = ({
	getInitialState: getInitialState,
	actions: actions
});

/***/ }),

/***/ "P84h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (typeof window !== 'undefined' ? window : {
	addEventListener: function addEventListener() {},
	removeEventListener: function removeEventListener() {},
	innerWidth: 768,
	innerHeight: 1024
});

/***/ }),

/***/ "QkG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackPageview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackEvent; });
var firstLoad = true;

var trackPageview = function trackPageview() {
	if (typeof window.ga === 'function' && !firstLoad) {
		window.ga('set', 'page', location.pathname + location.search);
		window.ga('send', 'pageview');
	} else {
		firstLoad = false;
	}
};

var trackEvent = function trackEvent(eventCategory, eventAction, eventLabel) {
	if (typeof window.ga === 'function') {
		window.ga('send', {
			hitType: 'event',
			eventCategory: eventCategory,
			eventAction: eventAction,
			eventLabel: eventLabel
		});
	}
};

/***/ }),

/***/ "SNoI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link":"gj_ae","tight":"gj_m","active":"gj_gl","linkWrapper":"gj_gn"};

/***/ }),

/***/ "Yr0O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Helmet = function (_Component) {
	_inherits(Helmet, _Component);

	function Helmet() {
		_classCallCheck(this, Helmet);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Helmet.prototype.componentDidMount = function componentDidMount() {
		document.title = this.props.title;
	};

	return Helmet;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Helmet);

/***/ }),

/***/ "ZMjw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"a0_e","footer":"a0_a0","link":"a0_ae","logo":"a0_co","links":"a0_bx","logos":"a0_cq","inner":"a0_au"};

/***/ }),

/***/ "f43Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_analytics__ = __webpack_require__("QkG9");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getInitialState = function getInitialState() {
	return { view: 'country' };
};


var actions = {
	switch: function _switch(state, id) {
		Object(__WEBPACK_IMPORTED_MODULE_0_utils_analytics__["a" /* trackEvent */])('Map view', 'Update', 'By ' + id);
		return _extends({}, state, { view: id });
	}
};

/* harmony default export */ __webpack_exports__["b"] = ({
	getInitialState: getInitialState,
	actions: actions
});

/***/ }),

/***/ "o6ac":
/***/ (function(module, exports, __webpack_require__) {

var t = __webpack_require__("KM04");function n(t, n) {
  "function" == typeof t && (t = t(n));var r = {};for (var e in t) {
    r[e] = n.action(t[e]);
  }return r;
}function r(t) {
  return "string" == typeof t && (t = t.split(/\s*,\s*/)), function (n) {
    for (var r = {}, e = 0; e < t.length; e++) {
      r[t[e]] = n[t[e]];
    }return r;
  };
}function e(t, n) {
  for (var r in n) {
    t[r] = n[r];
  }return t;
}function o(o, i) {
  return "function" != typeof o && (o = r(o || [])), function (r) {
    function u(u, c) {
      var f = this,
          s = c.store,
          p = o(s ? s.getState() : {}, u),
          a = i ? n(i, s) : { store: s },
          l = function l() {
        var t = o(s ? s.getState() : {}, f.props);for (var n in t) {
          if (t[n] !== p[n]) return p = t, f.setState(null);
        }for (var r in p) {
          if (!(r in t)) return p = t, f.setState(null);
        }
      };this.componentDidMount = function () {
        l(), s.subscribe(l);
      }, this.componentWillUnmount = function () {
        s.unsubscribe(l);
      }, this.render = function (n) {
        return t.h(r, e(e(e({}, a), n), p));
      };
    }return (u.prototype = new t.Component()).constructor = u;
  };
}function i(t) {
  this.getChildContext = function () {
    return { store: t.store };
  };
}i.prototype.render = function (t) {
  return t.children[0];
}, exports.connect = o, exports.Provider = i;
//# sourceMappingURL=preact.js.map

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "t8lY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getInitialState = function getInitialState() {
  return { open: null };
};

var actions = {
  open: function open(state, id) {
    return _extends({}, state, { open: id });
  },
  close: function close(state) {
    return _extends({}, state, { open: null });
  }
};

/* harmony default export */ __webpack_exports__["b"] = ({
  getInitialState: getInitialState,
  actions: actions
});

/***/ }),

/***/ "tcm7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"b_e","large":"b_g","title":"b_i","content":"b_k","tight":"b_m"};

/***/ }),

/***/ "u3et":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"ay_ay","inner":"ay_au","links":"ay_bx","headerTitle":"ay_bz","menuToggle":"ay_b1","hamburger":"ay_b3","hamburgerClose":"ay_b5","overlay":"ay_b7","link":"ay_ae","navLinks":"ay_b9"};

/***/ }),

/***/ "yMZu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__("OrX5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("9qb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M11.4 3.31l7.6 7.63H1.56A1.56 1.56 0 0 0 0 12.5a1.56 1.56 0 0 0 1.56 1.56H19l-7.6 7.63a1.56 1.56 0 0 0 0 2.21 1.55 1.55 0 0 0 2.2 0L25 12.5 13.6 1.1a1.55 1.55 0 0 0-2.2 0 1.56 1.56 0 0 0 0 2.21z' });

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M22.92 19.79a1.9 1.9 0 0 1-1.46-.62l-9-9-9 9a2 2 0 0 1-2.92 0 2 2 0 0 1 0-2.92L11 5.83a2 2 0 0 1 2.92 0l10.46 10.42a2 2 0 0 1 0 2.92 1.93 1.93 0 0 1-1.46.62z' });

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
	transform: 'translate(5.000000, 5.000000)',
	d: 'M9.34233162,7.49932495 L14.6052789,2.23685133 C14.857343,1.9967552 15,1.66386472 15,1.31576843 C15,0.967672143 14.857343,0.634781661 14.6052789,0.394685534 C14.3651612,0.142644118 14.0322408,3.03690676e-16 13.6841131,2.82351657e-16 C13.3359855,2.61012638e-16 13.0030651,0.142644118 12.7629473,0.394685534 L7.5,5.65715915 L2.23705268,0.394685534 C1.99693494,0.142644118 1.66401449,2.10787873e-17 1.31588687,0 C0.967759248,-2.13390192e-17 0.634838801,0.142644118 0.394721062,0.394685534 C0.142656958,0.634781661 4.29421355e-17,0.967672143 0,1.31576843 C-4.26818802e-17,1.66386472 0.142656958,1.9967552 0.394721062,2.23685133 L5.65766838,7.49932495 L0.394721062,12.7617986 C0.142656958,13.0018947 4.29421355e-17,13.3347852 0,13.6828815 C-4.26818802e-17,14.0309777 0.142656958,14.3638682 0.394721062,14.6039644 C0.642125293,14.8436823 0.968727425,14.9845568 1.31288633,15 C1.65876589,14.9843584 1.98718735,14.843619 2.23705268,14.6039644 L7.5,9.34149074 L12.7629473,14.6039644 C13.0030651,14.8560058 13.3359855,14.9986499 13.6841131,14.9986499 C14.0322408,14.9986499 14.3651612,14.8560058 14.6052789,14.6039644 C14.857343,14.3638682 15,14.0309777 15,13.6828815 C15,13.3347852 14.857343,13.0018947 14.6052789,12.7617986 L9.34233162,7.49932495 Z'
});

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'g',
	null,
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M21.88 17.19v4.69H3.12v-4.69a1.56 1.56 0 0 0-1.56-1.57A1.56 1.56 0 0 0 0 17.19V25h25v-7.81a1.56 1.56 0 0 0-1.56-1.57 1.56 1.56 0 0 0-1.56 1.57z' }),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M14.06 11.72V1.56A1.56 1.56 0 0 0 12.5 0a1.56 1.56 0 0 0-1.56 1.56v10.16H6.25L12.5 18l6.25-6.25z' })
);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M14.47 25h-5.3V12.5H6.52V8.19h2.65V5.6c0-3.51 1.5-5.6 5.75-5.6h3.53v4.31h-2.21c-1.65 0-1.76.6-1.76 1.72v2.16h4L18 12.5h-3.53V25z' });

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'g',
	null,
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M23.37 6.9H1.63A1.07 1.07 0 0 1 .5 5.76a1.07 1.07 0 0 1 1.13-1.13h21.74a1.07 1.07 0 0 1 1.13 1.13 1.07 1.07 0 0 1-1.13 1.14zm0 6.68H1.63A1.07 1.07 0 0 1 .5 12.44a1.07 1.07 0 0 1 1.13-1.13h21.74a1.07 1.07 0 0 1 1.13 1.13 1.07 1.07 0 0 1-1.13 1.14zm0 6.79H1.63a1.14 1.14 0 0 1 0-2.27h21.74a1.14 1.14 0 0 1 0 2.27z' })
);

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M.63 8H5.5v17H.63zm2.31-2.11A2.82 2.82 0 0 1 0 3a2.84 2.84 0 0 1 3-3 2.82 2.82 0 0 1 2.91 3 2.83 2.83 0 0 1-3 2.94zM25 25h-5.53v-8.79c0-2.3-.86-3.87-2.76-3.87a2.84 2.84 0 0 0-2.64 2.08 4.29 4.29 0 0 0-.07 1.39V25H8.48s.07-15.57 0-17H14v2.66c.33-1.16 2.07-2.83 4.87-2.83 3.46 0 6.18 2.45 6.18 7.71V25z' });

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M2.4 9A6.63 6.63 0 0 1 .77 7.47 2.92 2.92 0 0 1 0 5.7 2.47 2.47 0 0 1 .58 4a2.08 2.08 0 0 1 1.65-.67h20.54a2.23 2.23 0 0 1 1.57.67A1.91 1.91 0 0 1 25 5.42a3.28 3.28 0 0 1-.68 2A6.51 6.51 0 0 1 22.61 9l-6.52 4.19c-.1.06-.3.19-.6.4l-.75.49-.73.42a4.88 4.88 0 0 1-.8.35 2.6 2.6 0 0 1-.7.11 2.6 2.6 0 0 1-.7-.11 4.88 4.88 0 0 1-.8-.35l-.75-.5-.75-.49-.6-.4-3.65-2.31zm21.2 1.38A7.56 7.56 0 0 0 25 9.22v10.25a1.92 1.92 0 0 1-.66 1.46 2.23 2.23 0 0 1-1.57.6H2.23a2.23 2.23 0 0 1-1.57-.6A1.92 1.92 0 0 1 0 19.47V9.22a7.47 7.47 0 0 0 1.41 1.12q5.06 3.18 6.93 4.45c.53.37 1 .65 1.29.85a8.32 8.32 0 0 0 1.32.62 4.33 4.33 0 0 0 1.54.32 4.33 4.33 0 0 0 1.54-.32 8.32 8.32 0 0 0 1.32-.62c.33-.2.76-.48 1.29-.85Q19 13.2 23.6 10.34z' });

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M22.92 14.58H2.08A2 2 0 0 1 0 12.5a2 2 0 0 1 2.08-2.08h20.84A2 2 0 0 1 25 12.5a2 2 0 0 1-2.08 2.08z' });

var _ref10 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M22.92 10.42h-8.34V2.08A2 2 0 0 0 12.5 0a2 2 0 0 0-2.08 2.08v8.34H2.08A2 2 0 0 0 0 12.5a2 2 0 0 0 2.08 2.08h8.34v8.34A2 2 0 0 0 12.5 25a2 2 0 0 0 2.08-2.08v-8.34h8.34A2 2 0 0 0 25 12.5a2 2 0 0 0-2.08-2.08z' });

var _ref11 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M22.05 5.17a5.38 5.38 0 0 0 2.26-3 9.88 9.88 0 0 1-3.26 1.31 5 5 0 0 0-3.74-1.7 5.27 5.27 0 0 0-5.13 5.4 5.61 5.61 0 0 0 .13 1.24A14.33 14.33 0 0 1 1.74 2.77a5.67 5.67 0 0 0-.69 2.73A5.48 5.48 0 0 0 3.33 10 4.94 4.94 0 0 1 1 9.32v.07a5.34 5.34 0 0 0 4.12 5.3 4.64 4.64 0 0 1-1.35.19 5.15 5.15 0 0 1-1-.09 5.16 5.16 0 0 0 4.79 3.75 9.89 9.89 0 0 1-6.37 2.32A8.24 8.24 0 0 1 0 20.78a14 14 0 0 0 7.86 2.43c9.44 0 14.59-8.24 14.59-15.39v-.7A10.71 10.71 0 0 0 25 4.32a9.83 9.83 0 0 1-2.95.85z' });

var icons = {
	arrow: function arrow() {
		return _ref;
	},
	carrot: function carrot() {
		return _ref2;
	},
	close: function close() {
		return _ref3;
	},
	download: function download() {
		return _ref4;
	},
	facebook: function facebook() {
		return _ref5;
	},
	hamburger: function hamburger() {
		return _ref6;
	},
	linkedin: function linkedin() {
		return _ref7;
	},
	mail: function mail() {
		return _ref8;
	},
	minus: function minus() {
		return _ref9;
	},
	plus: function plus() {
		return _ref10;
	},
	twitter: function twitter() {
		return _ref11;
	}
};

var sizes = {
	s: 14,
	m: 25,
	l: 32
};

var Icon = function Icon(_ref12) {
	var _cn;

	var _ref12$icon = _ref12.icon,
	    icon = _ref12$icon === undefined ? 'arrow' : _ref12$icon,
	    className = _ref12.className,
	    _ref12$size = _ref12.size,
	    size = _ref12$size === undefined ? 's' : _ref12$size,
	    title = _ref12.title,
	    rest = _objectWithoutProperties(_ref12, ['icon', 'className', 'size', 'title']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'svg',
		_extends({
			className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style_css___default.a.icon, (_cn = {}, _cn[className] = className, _cn)),
			width: sizes[size] + 'px',
			height: sizes[size] + 'px',
			viewBox: '0 0 25 25',
			fill: 'currentColor'
		}, rest),
		title && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'title',
			null,
			title
		),
		icons[icon]()
	);
};

/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),

/***/ "zhmh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getInitialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_window__ = __webpack_require__("P84h");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var getInitialState = function getInitialState() {
	return {
		x: 0,
		y: 0,
		zoom: 1.02,
		width: __WEBPACK_IMPORTED_MODULE_0_state_window__["a" /* default */].innerWidth,
		height: __WEBPACK_IMPORTED_MODULE_0_state_window__["a" /* default */].innerHeight
	};
};

var setZoom = function setZoom(state, scale) {
	var x = state.x,
	    y = state.y,
	    zoom = state.zoom,
	    width = state.width,
	    height = state.height;

	var nextZoom = zoom * scale;
	if (nextZoom > 6 || nextZoom < 1.01) {
		return state;
	}
	return _extends({}, state, {
		x: x * scale + (1 - scale) * width / 2,
		y: y * scale + (1 - scale) * height / 2,
		zoom: nextZoom
	});
};

var setCenter = function setCenter(state, x, y) {
	return _extends({}, state, {
		x: Math.max(Math.min(x, 0), state.zoom === 1 ? 0 : -state.width * (state.zoom - 0.8)),
		y: Math.max(Math.min(y, 0), state.zoom === 1 ? 0 : -state.height * (state.zoom - 1))
	});
};

var focusOn = function focusOn(state, x, y) {
	return setCenter(state, -(x * state.zoom - state.width / 2), -(y * state.zoom - state.height / 2));
};

var reset = getInitialState;
var zoomIn = function zoomIn(state) {
	return setZoom(state, 1.5);
};
var zoomOut = function zoomOut(state) {
	return setZoom(state, 0.5);
};
var resize = function resize(state) {
	var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0_state_window__["a" /* default */].innerWidth;
	var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0_state_window__["a" /* default */].innerHeight;
	return _extends({}, state, {
		width: width,
		height: height
	});
};

var actions = { setCenter: setCenter, focusOn: focusOn, reset: reset, zoomIn: zoomIn, zoomOut: zoomOut, resize: resize };

/* harmony default export */ __webpack_exports__["b"] = ({
	getInitialState: getInitialState,
	actions: actions
});

/***/ }),

/***/ "zwl0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_main__ = __webpack_require__("8BXp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("9qb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css__ = __webpack_require__("tcm7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_helmet__ = __webpack_require__("Yr0O");






var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_utils_helmet__["a" /* default */], { title: 'Faces of Energy' });

var Page = function Page(_ref) {
	var _cn;

	var title = _ref.title,
	    children = _ref.children,
	    large = _ref.large,
	    full = _ref.full;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_1_layouts_main__["a" /* default */],
		{ fullSize: full },
		title && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_utils_helmet__["a" /* default */], { title: title + ' \u2013 Faces of Energy' }),
		!title && _ref2,
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__style_css___default.a.wrapper, (_cn = {}, _cn[__WEBPACK_IMPORTED_MODULE_3__style_css___default.a.large] = large, _cn[__WEBPACK_IMPORTED_MODULE_3__style_css___default.a.tight] = full, _cn)) },
			title && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'h2',
				{ className: __WEBPACK_IMPORTED_MODULE_3__style_css___default.a.title },
				title
			),
			children && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_3__style_css___default.a.content, key: title },
				children
			)
		)
	);
};

/* harmony default export */ __webpack_exports__["a"] = (Page);

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.a42e7.js